import * as dashboardActions from "./actions"

import { all, call, put, takeEvery } from "redux-saga/effects"
import {
  getApplicantsReport,
  getApplicantsStatus,
  getStats,
  getTotalJobsAndApplicant,
  getTotalApplicantsReports,
  getOpenJobByCategory,
  getTotalApplicantsFunnel,
  getApplicationsReceivedByCategory,
  getJobPostByJobType,
  getJobAcceptedRatio,
  getJobByTitle,
  getLocationData,
  getApplicantByGender
} from "@src/services/apis"

import { DASHBOARD } from "./types"

function* getStatsRequest(action) {
  try {
    const response = yield call(getStats, action.payload)
    yield put(dashboardActions.getStatsSuccess(response.data))
  } catch (err) {
    yield put(dashboardActions.getStatsFailure(err))
  }
}

function* getApplicantsStatusRequest(action) {
  try {
    const response = yield call(getApplicantsStatus, action.payload)
    yield put(dashboardActions.getApplicantsStatusSuccess(response.data))
  } catch (err) {
    yield put(dashboardActions.getApplicantsStatusFailure(err))
  }
}

function* getApplicantsReportRequest(action) {
  try {
    const response = yield call(getApplicantsReport, action.payload)
    if (response.status === 200) {
      yield put(dashboardActions.getApplicantsReportSuccess(response.data))
    } else {
      yield put(dashboardActions.getApplicantsReportFailure(response.data))
    }
  } catch (err) {
    yield put(dashboardActions.getApplicantsReportFailure(err))
  }
}

function* getTotalJobsAndApplicantRequest(action) {
  try {
    const response = yield call(getTotalJobsAndApplicant, action.payload)
    yield put(dashboardActions.getTotalJobsAndApplicantSuccess(response))
  } catch (err) {
    yield put(dashboardActions.getTotalJobsAndApplicantFailure(err))
  }
}

function* getTotalApplicantsReportsRequest(action) {
  try {
    const response = yield call(getTotalApplicantsReports, action.payload)
    yield put(dashboardActions.getTotalApplicantsReportsSuccess(response))
  } catch (err) {
    yield put(dashboardActions.getTotalApplicantsReportsFailure(err))
  }
}

function* getOpenJobByCategoryRequest(action) {
  try {
    const response = yield call(getOpenJobByCategory, action.payload)
    yield put(dashboardActions.getOpenJobByCategorySuccess(response))
  } catch (err) {
    yield put(dashboardActions.getOpenJobByCategoryFailure(err))
  }
}

function* getTotalApplicantsFunnelRequest(action) {
  try {
    const response = yield call(getTotalApplicantsFunnel, action.payload)
    yield put(dashboardActions.getTotalApplicantsFunnelSuccess(response))
  } catch (err) {
    yield put(dashboardActions.getTotalApplicantsFunnelFailure(err))
  }
}

function* getApplicationsReceivedByCategoryRequest(action) {
  try {
    const response = yield call(
      getApplicationsReceivedByCategory,
      action.payload
    )
    yield put(
      dashboardActions.getApplicationsReceivedByCategorySuccess(response)
    )
  } catch (err) {
    yield put(dashboardActions.getApplicationsReceivedByCategoryFailure(err))
  }
}

function* getJobPostByJobTypeRequest(action) {
  try {
    const response = yield call(getJobPostByJobType, action.payload)
    yield put(dashboardActions.getJobPostByJobTypeSuccess(response))
  } catch (err) {
    yield put(dashboardActions.getJobPostByJobTypeFailure(err))
  }
}

function* getJobAcceptedRatioRequest(action) {
  try {
    const response = yield call(getJobAcceptedRatio, action.payload)
    yield put(dashboardActions.getJobAcceptedRatioSuccess(response))
  } catch (err) {
    yield put(dashboardActions.getJobAcceptedRatioFailure(err))
  }
}

function* getJobByTitleRequest(action) {
  try {
    const response = yield call(getJobByTitle, action.payload)
    yield put(dashboardActions.getJobByTitleSuccess(response))
  } catch (err) {
    yield put(dashboardActions.getJobByTitleFailure(err))
  }
}

function* getLocationDataRequest(action) {
  try {
    const response = yield call(getLocationData, action.payload)
    yield put(dashboardActions.getLocationDataSuccess(response))
  } catch (err) {
    yield put(dashboardActions.getLocationDataFailure(err))
  }
}

function* getApplicantByGenderRequest(action) {
  try {
    const response = yield call(getApplicantByGender, action.payload)
    yield put(dashboardActions.getApplicantByGenderSuccess(response))
  } catch (err) {
    yield put(dashboardActions.getApplicantByGenderFailure(err))
  }
}

export default function* dashboardSaga() {
  yield all([
    takeEvery(DASHBOARD.GET_STATS_REQUEST, getStatsRequest),
    takeEvery(
      DASHBOARD.GET_APPLICANTS_STATUS_REQUEST,
      getApplicantsStatusRequest
    ),
    takeEvery(
      DASHBOARD.GET_APPLICANTS_REPORT_REQUEST,
      getApplicantsReportRequest
    ),
    takeEvery(
      DASHBOARD.GET_TOTAL_JOBS_AND_APPLICANT_REQUEST,
      getTotalJobsAndApplicantRequest
    ),
    takeEvery(
      DASHBOARD.GET_TOTAL_APPLICANTS_REPORTS_REQUEST,
      getTotalApplicantsReportsRequest
    ),
    takeEvery(
      DASHBOARD.GET_OPEN_JOB_BY_CATEGORY_REQUEST,
      getOpenJobByCategoryRequest
    ),
    takeEvery(
      DASHBOARD.GET_TOTAL_APPLICANTS_FUNNEL_REQUEST,
      getTotalApplicantsFunnelRequest
    ),
    takeEvery(
      DASHBOARD.GET_APPLICATIONS_RECEIVED_BY_CATEGORY_REQUEST,
      getApplicationsReceivedByCategoryRequest
    ),
    takeEvery(
      DASHBOARD.GET_JOB_POST_BY_JOB_TYPE_REQUEST,
      getJobPostByJobTypeRequest
    ),
    takeEvery(
      DASHBOARD.GET_JOB_ACCEPTED_RATIO_REQUEST,
      getJobAcceptedRatioRequest
    ),
    takeEvery(DASHBOARD.GET_JOB_BY_TITLE_REQUEST, getJobByTitleRequest),
    takeEvery(DASHBOARD.GET_LOCATION_DATA_REQUEST, getLocationDataRequest),
    takeEvery(
      DASHBOARD.GET_APPLICANT_BY_GENDER_REQUEST,
      getApplicantByGenderRequest
    )
  ])
}
